import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';
import { bindActionCreators } from 'redux';

import formatCurrency from 'rebook/apps/utils/text/formatCurrency';
import Form, { FormRow, FormControl } from 'rebook/apps/base/components/form/Form';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import fetchQuery from 'rebook/apps/utils/fetchQuery';
import Button from 'rebook/apps/base/components/Button';
import ModalDialog from 'rebook/mybook/App/ModalDialogs/ModalDialog';
import validateForm from 'rebook/apps/base/components/form/validateForm';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import { URLS } from 'rebook/apps/base/constants';
import { OFFER_PAGE_ERROR_MESSAGES } from 'rebook/apps/offer/constants';
import OfferCardHeaderItem from 'rebook/apps/offer/components/OfferCardHeaderItem';
import OfferCardBillingInfo from 'rebook/apps/offer/components/OfferCardBillingInfo';
import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';

import styles from './style.scss';


class OfferView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {},
      errorList: {},
      isDisabled: false,
      isInProgress: false,
      offerPayment: null,
    };
  }

  onBeforeSubmit() {
    ga('send', 'event', 'Registration', 'PushButton', 'Offer');
  }

  updateFormField(input) {
    this.setState(
      (prevState) => {
        return {
          errorList: {},
          form: {
            ...prevState.form,
            ...input,
          },
        };
      }
    );
  }

  handleOpenPayonline() {
    this.setState({
      errorList: {},
      isInProgress: true,
    });
    const options = {
      method: 'post',
      json: {
        provider: 'web',
        data: {
          payment_method: 'credit_card',
          sub_months: 1,
          sub_type: 'audio',
          auto_rebill: true,
          redeem_code: 'offeraudio',
        },
      },
    };
    fetchQuery('/api/payments/', options)
      .then(({ data }) => {
        this.setState({
          offerPayment: data,
          isInProgress: false,
        });
      })
      .catch(({ data, resp }) => {
        Raven.captureMessage('failed to submit offer payment list due to server error', {
          level: 'error',
          extra: {
            status: resp.status,
            response: data,
          },
        });
        this.setState({ isInProgress: false });
        this.props.NotificationActions.pop(data[0], 'error');
      });
  }

  handleSubmit(submit) {
    const { user } = this.props;
    if (!user) {
      const form = validateForm(this.state.form);
      submit(form);
      this.setState({
        errorList: {},
        isInProgress: true,
      });
    }
    else {
      this.handleOpenPayonline();
    }
  }

  handleSuccess() {
    ga('send', 'event', 'Registration', 'Registration', 'Offer');
    yaMetrikaReachGoal('Registration');
    this.setState({ isInProgress: false });
    window.location.assign('/offer/');
  }

  handleError(errorList) {
    this.setState({
      errorList,
      isInProgress: false,
    });

    if (errorList.non_field_errors) {
      this.props.NotificationActions.pop(errorList.non_field_errors, 'error');
    }
  }

  handlePushOfferButton() {
    ga('send', 'event', 'Registration', 'PushButtonOffer', 'Offer');
  }

  handleCloseModalWindow() {
    this.setState({ offerPayment: null });
  }

  getPayDialog() {
    const { offerPayment } = this.state;
    if (!offerPayment) {
      return null;
    }

    return (
      <ModalDialog onClose={() => { this.handleCloseModalWindow();}} dialog={
        {
          id: '1',
          extraClassName: 'jest-payonline-window',
          emojiIcon: '',
          title: '',
          content:
            <div>
              <iframe
                width="100%"
                height="516"
                className={styles.trialForm}
                src={offerPayment.redirect_url}
                frameBorder="0" />
            </div>,
        }
      } />
    );
  }

  render() {
    const { errorList, isDisabled, isInProgress, offerPayment } = this.state;
    const { user, offer, booksPerSubscriptionCounter } = this.props;
    const modalWindow = this.getPayDialog();
    const userHadAudio = !!get(user, 'subscription_audio_active_till', null);

    return (
      <React.Fragment>
        <div className={classNames(styles.offerPage)}>
          <div className={styles.header}>
            <h1>
              Первый месяц премиум-подписки <br className={styles.wordWrap} />за {`${formatCurrency(199, 'RUB')}`}
            </h1>
          </div>
          {offerPayment ? modalWindow : null}
          <div className={styles.offerForm}>
            <div className={styles.title}>
              <OfferCardHeaderItem imageStyleName={styles.proSubscriptionIcon}>
                <span>
                  Читайте&nbsp;
                  <b>
                    {numberWithSpace(booksPerSubscriptionCounter.total)}
                    &nbsp;книг&nbsp;
                  </b>
                </span>
                <span>
                  и слушайте&nbsp;
                  <b>
                    {numberWithSpace(booksPerSubscriptionCounter.audio)}
                  </b>
                  <b>&nbsp;аудиокниг</b>
                </span>
                <span>&nbsp;по одной подписке</span>
              </OfferCardHeaderItem>
              <OfferCardHeaderItem className={styles.showOnDesktop} imageStyleName={styles.calendarIcon}>
                <span>
                  Через <b>1 месяц</b> подписка будет продлеваться за&nbsp;
                  <b>{formatCurrency(459, 'RUB')} ежемесячно</b>
                </span>
              </OfferCardHeaderItem>
            </div>
            {get(offer, 'errors.length', 0) > 0 || userHadAudio && (
              <div className={styles.subscriptionAlert}>
                <div className={styles.subscriptionAlertImage} />
                <span className={styles.subscriptionAlertTitle}>
                  Вы не можете воспользоваться этим предложением, потому что у вас уже была такая подписка
                </span>
              </div>
            )}
            {!userHadAudio && get(offer, 'errors.length', 0) === 0 &&
              <Form
                action="/api/registration/"
                method="post"
                extraClassName={classNames('jest-offer-form', styles.form)}
                onBeforeSubmit={() => this.onBeforeSubmit()}
                onSubmit={(callback) => this.handleSubmit(callback)}
                onSuccess={(data) => this.handleSuccess(data)}
                onError={(errorList) => this.handleError(errorList)}>
                {!user && (
                  <FormRow>
                    <FormTextInput
                      extraClassName={classNames('jest-email-form-input', styles.input)}
                      validationMessageExtraClassName="jest-email-form-input-error"
                      errorList={errorList.email}
                      isDisabled={isDisabled || isInProgress}
                      isRequired
                      isRequiredError={OFFER_PAGE_ERROR_MESSAGES.EMAIL_IS_REQUIRED}
                      label="Введите вашу электронную почту"
                      onUpdate={(input) => this.updateFormField(input)}
                      name="email" />
                  </FormRow>
                )}
                <FormControl>
                  <Button
                    type="submit"
                    extraClassName="jest-registration-form-submit"
                    size="small"
                    theme="advert"
                    isInProgress={isInProgress}>
                    Оформить подписку
                  </Button>
                </FormControl>
              </Form>
            }
          </div>
          <div className={styles.billingInfoContainer}>
            <OfferCardBillingInfo imageStyleName={styles.applyIcon}>
              <span className={styles.note}>
                Оплачивая подписку, я принимаю&nbsp;
                <Link to={`${URLS.aboutOffer}#a4.4`} className="link">условия оплаты, указанные в оферте,</Link>
                <span>
                  &nbsp;и&nbsp;
                  <Link to={`${URLS.aboutOffer}#a4.4`} className="link">
                    условия автоматического продления подписки на месяц вперед.
                  </Link>
                </span>
              </span>
            </OfferCardBillingInfo>
            <OfferCardBillingInfo imageStyleName={styles.noComissionIcon}>
              <span>Отменить платное продление подписки можно в любой момент в настройках</span>
            </OfferCardBillingInfo>
            <OfferCardBillingInfo imageStyleName={styles.lockIcon}>
              <span>Все платежи надежно защищены и соответствуют международным стандартам.</span>
            </OfferCardBillingInfo>
          </div>
        </div>
        <div className={styles.backgroundImageContainer}>
          <div className={styles.backgroundImage} />
        </div>
      </React.Fragment>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    payments: state.payments,
    offer: state.offer,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
};

const mapDispatchToProps = (dispatch) => ({
  NotificationActions: bindActionCreators(NotificationActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(OfferView);
